module.exports = __webpack_public_path__ + "img/loginovskaya.8b520d63.png";